'use client';
import { useNavigation } from './NavigationContext';

export function usePathnameData() {
  const { isLoaded, pathname, currentUrl } = useNavigation();
  
  const cleanPathname = pathname.split('#')[0];
  return { isLoaded, pathname: cleanPathname, currentUrl };
}
